import React, { useState, useEffect } from 'react';
import { useAuth } from '../../contexts/AuthContext';
import AuthService from '../../services/auth-service';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "./card";

export const TestAuth: React.FC = () => {
  const { isAuthenticated } = useAuth();
  const [user, setUser] = useState<any>(null);
  const [token, setToken] = useState<string | null>(null);

  useEffect(() => {
    const currentUser = AuthService.getUser();
    const currentToken = AuthService.getToken();
    setUser(currentUser);
    setToken(currentToken);
  }, []);

  return (
    <div className="p-8 bg-background min-h-screen">
      <div className="max-w-4xl mx-auto">
        <Card>
          <CardHeader>
            <CardTitle>Auth Test</CardTitle>
            <CardDescription>Testing authentication context and service</CardDescription>
          </CardHeader>
          <CardContent>
            <div className="space-y-4">
              <div>
                <h3 className="font-medium">Auth Context:</h3>
                <p>Is Authenticated: {isAuthenticated ? 'Yes' : 'No'}</p>
              </div>
              
              <div>
                <h3 className="font-medium">Auth Service:</h3>
                <p>Token: {token ? 'Present' : 'Not present'}</p>
                <p>User: {user ? JSON.stringify(user) : 'Not present'}</p>
              </div>
            </div>
          </CardContent>
        </Card>
      </div>
    </div>
  );
};

export default TestAuth;